package com.sweetlime.bingeamigo.presentation.features.user

import androidx.compose.runtime.Composable
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow

data class UserProfileScreen(
    val userId: String
) : Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow

        UserProfileContent(
            userId = userId,
            onBackClick = { navigator.pop() }
        )
    }
}